"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _whiteX = _interopRequireDefault(require("../../../../images/white-x.svg"));

var _whiteBackArrow = _interopRequireDefault(require("../../../../images/white-back-arrow.svg"));

require("./GradientModalHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GradientModalHeader = function GradientModalHeader(_ref) {
  var closeModal = _ref.closeModal,
      handleGoBack = _ref.handleGoBack,
      headerCopy = _ref.headerCopy,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type;
  var headerClasses = (0, _classnames.default)('modal-2020-gradient-header', {
    delete: type === 'delete'
  });
  var backButtonClasses = (0, _classnames.default)({
    'handle-back': true,
    'is-visible': !!handleGoBack
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: headerClasses
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: backButtonClasses,
    onClick: handleGoBack
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _whiteBackArrow.default,
    alt: "white-back-arrow"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "copy-header"
  }, headerCopy), /*#__PURE__*/_react.default.createElement("button", {
    className: "close-modal",
    onClick: closeModal
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _whiteX.default,
    alt: "close-modal"
  })));
};

var string = _propTypes.default.string,
    func = _propTypes.default.func,
    oneOf = _propTypes.default.oneOf;
GradientModalHeader.propTypes = {
  closeModal: func.isRequired,
  handleGoBack: func,
  headerCopy: string.isRequired,
  type: oneOf(['primary', 'delete'])
};
var _default = GradientModalHeader;
exports.default = _default;